import Serializer from 'umg-ember-backend/serializers/application';

export default class ProductFamilySerializer extends Serializer {
  attrs = {
    ownedByChannel: 'ownedByChannelId',
  };
}
